import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import mitt from 'mitt';
import { ZiggyVue } from "../../vendor/tightenco/ziggy/dist/vue";

import AppLayout from "./pages/Layouts/AppLayout";
import GuestLayout from "./pages/Layouts/GuestLayout";

const emitter = mitt();

createInertiaApp({
  resolve: name => {
    const page = require(`./pages/${name}`).default;

    page.layout = AppLayout;

    if (name.startsWith('Auth/')) {
      page.layout = GuestLayout;
    }

    return page;
  },
  setup({el, App, props, plugin}) {
    const app = createApp({render: () => h(App, props)});

    app.use(
      plugin,
      ZiggyVue,
    );

    app.config.globalProperties.$route = route;
    app.config.globalProperties.emitter = emitter;

    app.mount(el)
  },
});
